import { Star } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { REVIEWS, BG } from "../lib/data";
import { useLang } from "../lib/i18n";
import { SectionBg } from "./SectionBg";

export default function Testimonials() {
  const { lang, t } = useLang();
  return (
    <section id="reviews" className="relative py-24 lg:py-32 border-y border-white/5 overflow-hidden">
      <SectionBg src={BG.reviews} opacity={0.3} testid="reviews-bg-image" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead tag={t.reviews.tag} title={t.reviews.title} sub={t.reviews.sub} />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {REVIEWS.map((r, i) => (
            <Reveal
              key={i}
              delay={0.05 * (i % 3)}
              className={`h-full ${r.highlight ? "md:col-span-2 lg:col-span-3" : ""}`}
            >
              <div
                data-testid={`testimonial-card-${i + 1}`}
                className={`h-full flex flex-col rounded-3xl border p-7 transition-all duration-500 hover:-translate-y-1.5 ${
                  r.highlight
                    ? "border-gold/50 bg-gradient-to-b from-gold/10 to-panel/80 items-center text-center justify-center"
                    : "border-white/10 bg-panel/70 hover:border-gold/40"
                }`}
              >
                <div className="flex gap-1 text-gold">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={15} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <p className={`text-slate-300 leading-relaxed mt-5 flex-1 ${r.highlight ? "max-w-2xl" : ""}`}>“{r.text}”</p>
                <div className={`mt-7 pt-5 border-t border-white/10 ${r.highlight ? "w-full max-w-md" : ""}`}>
                  <p className={`font-display font-bold ${r.highlight ? "text-gold" : "text-white"} text-sm`}>{r.service[lang]}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
